import type { ChatMessageType } from '@kanbu/schema';
import { Trans } from '@lingui/react/macro';
import { memo } from 'react';

import {
  AdminChatRenderer,
  type SourceCitationConfig,
} from '../../chat/AdminChatRenderer';

export interface MessageListProps {
  agentName: string | undefined;
  agentAvatar: string | undefined;
  chatbotConfig?: SourceCitationConfig;
  messages: ChatMessageType[] | undefined;
  /** Render the full tool-call inspector instead of the activity trail. */
  debug?: boolean;
  isVoice?: boolean;
}

export const InboxChat = memo(
  ({
    agentName,
    agentAvatar,
    chatbotConfig,
    messages,
    debug,
    isVoice,
  }: MessageListProps) => {
    if (!Array.isArray(messages) || messages.length === 0) {
      return (
        <div className='flex h-full flex-col items-center justify-start pt-12'>
          <p className='text-sm text-muted-fg'>
            <Trans>No messages</Trans>
          </p>
        </div>
      );
    }

    return (
      <div className='flex flex-col gap-4 p-4'>
        <div className='flex grow flex-col gap-6 [&>*:first-child]:mt-auto'>
          <AdminChatRenderer
            messages={messages}
            agentName={agentName}
            agentAvatar={agentAvatar}
            chatbotConfig={chatbotConfig}
            debug={debug}
            isVoice={isVoice}
          />
        </div>
      </div>
    );
  },
);
